import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()

export class HttpService {
    private baseUri = environment.baseURI;
    //options: any;
    constructor(private http: HttpClient) {
        //this.options = new HttpHeaders().set('Content-Type', 'application/json');
    }

    public get<T>(uri: string): Observable<T> {
        return this.http.get<T>(`${this.baseUri}${uri}`).pipe(
            catchError(this.handleError)
        );
    }

    public post<T, E>(uri: string, body: E): Observable<T> {
        return this.http.post<T>(`${this.baseUri}${uri}`, body).pipe(
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error);
    };
}
